
// import Covid from "../components/Covid/Covid";
// import Footer from "../components/Footer/Foot";
import Form from "../components/Form/Form";
import Hello from "../components/Hello";
import Hero from "../components/Hero/Hero";
// import Nav from "../components/Navbar/Nav";
import Provinsi from "../components/Provinsi/Provinsi";
// import Sum from "../components/Summary/Sum";
// import Two from "../components/Two/Two";


// function Main() {
//   return (
//     <main>
      
     
      // <Hello />
      // <Hero />
      // <Footer />
      // <Nav /> 
      // <Two />
      // <Provinsi />
      // <Form />

      
//     </main>
//   );
// }

function Home(props) {


  return (
    <div>
     
     
      {/* <Nav /> */}
      {/* <Hero /> */}
      {/* <Main />
      <Footer /> */}
     
      {/* <h1>Final Project - Covid ID</h1>
      <h2>Good Luck, Bestie</h2> */}
      <Hello />
      <Hero />
      {/* <Footer />
      <Nav /> */}
      {/* <Two /> */}
      <Provinsi />
      <Form />
     {/* <Covid /> */}
     {/* <Sum /> */}
     
      
     

      
      
     
     
    </div>
  );
}

export default Home;
